/* H5商城所有接口 */
import { Request } from '@/config/request'

const order = '/jic-order';        // 订单模块路径
const product = '/jic-product';    // 商品模块路径
const user = '/jic-member';        // 个人信息模块路径
const trade = '/jic-order';        // 订单模块路径
const conf = '/jic-manager';          // 配置中心模块路径
const market = '/jic-market';      // 商城中心模块路径
const manager = '/jic-manager';
const interaction = '/jic-interaction';
const point = "/jic-point";        // 积分中心模块

// 登录接口
export function doLogin(data = {}) {
    return Request(user + '/api/common/internal/memberLogin', { methods: 'POST', data });
}

// 获取手机验证码
export function sendIdentifyingCode(data = {}) {
    return Request(user + '/api/common/getMessageCode', { methods: 'POST', data, type: 'json' });
}

// 首页接口
export function mainIndex(data = {}) {
    return Request(product + '/productRest/getHomeProducts', { methods: 'POST', data });
}

// 个人中心接口
export function queryMember(data = {}) {
    return Request(user + '/api/common/myInformation', { methods: 'POST', data, type: 'json' });
}

// 个人中心评论数量
export function getProductCommentCount(data = {}) {
    return Request(conf + '/apiProductComment/getProductCommentCount', { methods: 'POST', data });
}

// 商品评价数据
export function getCommentCount(data = {}) {
    return Request(product + '/apiProductComment/queryCommentCount', { methods: 'POST', type: 'json', data });
}

// 商品评价数据
export function getProductCommentPage(data = {}) {
    return Request(product + '/apiProductComment/queryProductCommentListPage', { methods: 'POST', type: 'json', data });
}

// 个人中心订单数量
export function getOrderCountList(data = {}) {
    return Request(order + '/feign/queryOrderStatusCount', { methods: 'POST', type: 'json', data });
}

// 新增收货地址(编辑)
export function saveAddress(data = {}) {
    return Request(user + '/apiMyAddress/updateAddress', { methods: 'POST', data });
}

// 删除用户收货地址
export function deleteAddress(data = {}) {
    return Request(user + '/apiMyAddress/deleteAddress', { methods: 'POST', data });
}

// 查询用户收货地址
export function getAddressList(data = {}) {
    return Request(user + '/apiMyAddress/getAddressList', { methods: 'POST', data });
}

// 查询省市区地址
export function getNationalAddress(data = {}) {
    return Request(user + '/apiSysProvinceCity/getProvinceCityList', { methods: 'POST', data });
}

// 分类列表一级 二级 三级
export function queryAllTypeList(data = {}) {
    return Request('/productType/queryAllTypeList', { methods: 'GET', data });
}

// 推荐商品列表
export function getRecommendedProductList(data = {}) {
    return Request(product + '/productRest/getRecommendedProductList', { methods: 'POST', data });
}

// 商品详情
export function getProductInfo(data = {}) {
    return Request(product + '/productRest/queryProductDetail', { methods: 'POST', type: 'json', data });
}

// 添加店铺收藏
export function addCollectShop(data = {}) {
    return Request('/user/addCollectShop', { methods: 'POST', data });
}

// 添加商品收藏
export function addCollect(data = {}) {
    return Request('/user/addCollect', { methods: 'POST', data });
}

// 查询商品是否收藏 (应该和商品详情接口一起返commonOrderList回，不需要单独请求接口)
export function queryGoodsCollect(data = {}) {
    return Request('/user/queryGoodsCollect', { methods: 'POST', data });
}

// 查看店铺是否收藏 (应该和商品详情接口一起返回，不需要单独请求接口)
export function isCollectShop(data = {}) {
    return Request('/user/isCollectShop', { methods: 'POST', data });
}

// 查询用户收货地址
export function queryUserAddressInfo(data = {}) {
    return Request('/userAddress/queryUserAddressInfo', { methods: 'POST', data });
}

// 查询单个商品
export function queryProInfo(data = {}) {
    return Request(product + '/pro/queryProInfo', { methods: 'GET', data });
}

// 查询我的优惠券
export function queryMyCoupon(data = {}) {
    return Request(market + '/rest/coupon/query-coupon-person', { methods: 'POST', type: 'json', data })
}

// 查询优惠券中心
export function queryCouponCenter(data = {}) {
    return Request(market + '/rest/coupon/query-coupon-center', { methods: 'POST', type: 'json', data })
}

// 领取优惠券
export function receiveCoupon(data = {}) {
    return Request(market + '/rest/coupon/receive-coupon-person', { methods: 'POST', type: 'json', data })
}

// 查询商品优惠券
export function queryProductCoupon(data = {}) {
    return Request(market + '/rest/coupon/query-coupon-goodsId', { methods: 'POST', type: 'json', data })
}

// 查询当前用户优惠券
export function queryCoupon(data = {}) {
    return Request('/market/queryCoupon', { methods: 'GET', data });
}

// 添加到购物车
export function saveCartPro(data = {}) {
    return Request('/cart/saveCartPro', { methods: 'POST', data });
}

// 查询用户购物车
export function queryUserCart(data = {}) {
    return Request('/cart/queryUserCart', { methods: 'GET', data });
}

// 删除购物车
export function deleteCartPro(data = {}) {
    return Request('/cart/deleteCartPro', { methods: 'POST', data });
}

// 修改购物车
export function editProCartNum(data = {}) {
    return Request('/cart/editProCartNum', { methods: 'POST', data });
}

// 查询购物车数量
export function userCartNum(data = {}) {
    return Request(trade + '//shopping-cart/query-goods-num', { methods: 'POST', type: 'json', data });
}

// 查询优惠券配置
export function queryCouponPost(data = {}) {
    return Request('/market/queryCoupon', { methods: 'GET', data });
}

// 积分兑换
export function exchangeProduct(data = {}) {
    return Request('/order/exchangeProduct', { methods: 'POST', data });
}

//查询发票抬头
export function queryInvoiceInfo(data = {}) {
    return Request('/invoice/queryInvoiceInfo', { methods: 'GET', data });
}

//保存发票抬头
export function saveUserInvoice(data = {}) {
    return Request('/invoice/saveUserInvoice', { methods: 'POST', data });
}

// 商品（店铺）收藏列表
export function getFavoriteList(data = {}) {
    return Request(user + '/apiMyFavorite/getFavoriteList', { methods: 'POST', type: 'json', data });
}

// 店铺/商品-收藏/取消收藏 v.2.0
export function favorite(data = {}) {
    return Request(user + '/apiMyFavorite/editMyFavorite', { methods: 'POST', type: 'json', data });
}

// 选择规格
export function register(data = {}) {
    return Request('/register', { methods: 'POST', data });
}


// 订单列表接口
export function commonOrderList(data = {}) {
    return Request(order + '/order/queryAllList', { methods: 'POST', type: 'json', data })
}

// 前台类目
export function queryBeforeSecondCategory(data = {}) {
    return Request(product + '/categoryRest/queryBeforeSecondCategory', { methods: 'POST', data })
}

// 前台子类目
export function queryBeforeSecondSonCategory(data = {}) {
    return Request(product + '/categoryRest/queryBeforeSecondSonCategory', { methods: 'POST', data })
}

// 选择规格
export function detailSku(data = {}) {
    return Request(product + '/productRest/getProductsProperty', { methods: 'POST', data })
}

// 选择规格
export function skuEvent(data = {}) {
    return Request(product + '/productRest/getSkuList', { methods: 'POST', data })
}

// 取消订单
export function cancelOrder(data = {}) {
    return Request(order + '/order/close', { methods: 'POST', type: 'json', data })
}

// 订单确认收货
export function confirmShip(data = {}) {
    return Request(order + '/order/confirmShip', { methods: 'POST', type: 'json', data })
}

// 获取订单详情页
export function getOrderDetail(data = {}) {
    return Request(order + '/order/queryDetail', { methods: 'POST', type: 'json', data })
}

// 获取购物车列表
export function getCartList(data = {}) {
    return Request(trade + '/shopping-cart/query-shopping-cart', { methods: 'POST', data, type: 'json' })
}

//增加购物车商品数量
export function addGoodsNum(data = {}) {
    return Request(trade + '/shopping-cart/add-shopping-cart', { methods: 'POST', data, type: 'json' })
}

//删除购物车商品
export function deleteGoodsInCart(data = {}) {
    return Request(trade + '/shopping-cart/delete-shopping-cart', { methods: 'POST', data, type: 'json' })
}

//取消选中购物车里的商品
export function cancelGoodsInCart(data = {}) {
    /*return Request('/api/myEvaluation/getEvaluationList', { methods: 'POST', data });*/
    return Request(trade + '/shopping-cart/cancel-settle-shopping-cart', { methods: 'POST', data, type: 'json' })
}

//编辑购物车商品数量
export function editNum(data = {}) {
    return Request(trade + '/shopping-cart/editNum-shopping-cart', { methods: 'POST', data, type: 'json' })
}

//选中购物车中的商品
export function selectGoodsInCart(data = {}) {
    /*return Request('/api/myEvaluation/getEvaluationList', { methods: 'POST', data });*/
    return Request(trade + '/shopping-cart/select-settle-shopping-cart', { methods: 'POST', data, type: 'json' })
}


// 添加商品到购物车
export function addCart(data = {}) {
    return Request(trade + '/shopping-cart/add-shopping-cart', { methods: 'POST', type: 'json', data })
}

// 不加购物车直接结算
export function directSettle(data = {}) {
    return Request(trade + '/trade-settle/direct-settle', { methods: 'POST', type: 'json', data })
}

// 砍价商品结算
export function grouponSettle(data = {}) {
    return Request(trade + '/trade-settle/bargain-settle', { methods: 'POST', type: 'json', data })
}

// 购物车结算接口
export function shoppingCartSettlement(data = {}) {
    return Request(trade + '/trade-settle/settle', { methods: 'POST', type: 'json', data })
}

// 选择收货地址
export function tradeSettleAddress(data = {}) {
    return Request(trade + '/trade-settle/address', { methods: 'POST', type: 'json', data })
}

// 选择要使用的优惠券
export function tradeSettleCoupon(data = {}) {
    return Request(trade + '/trade-settle/coupon', { methods: 'POST', type: 'json', data })
}

// 提交订单
export function tradeSettleOrder(data = {}) {
    return Request(trade + '/trade-settle/order', { methods: 'POST', type: 'json', data })
}

// 提交秒杀订单
export function createSpikeOrder(data = {}) {
    return Request(order + '/order/createSpikeOrder', { methods: 'POST', type: 'json', data })
}

// 提交拼团订单
export function createJoinGroupOrder(data = {}) {
    return Request(order + '/order/createJoinGroupOrder', { methods: 'POST', type: 'json', data })
}


// 付款接口
export function pay(data = {}) {
    return Request(order + '/order/wxPay', { methods: 'POST', type: 'json', data })
}

// 申请售后接口
export function apply(data = {}) {
    return Request(order + '/afterSale/apply', { methods: 'POST', type: 'json', data })
}

// 取消售后
export function cancelAfter(data = {}) {
    return Request(order + '/afterSale/cancel', { methods: 'POST', type: 'json', data })
}

// 售后列表
export function afterList(data = {}) {
    return Request(order + '/afterSale/queryPageList', { methods: 'POST', type: 'json', data })
}

// 售后详情
export function afterDetail(data = {}) {
    return Request(order + '/afterSale/query', { methods: 'POST', type: 'json', data })
}

// 获取购物车猜你喜欢商品列表
export function getRecommendedGoodsList(data = {}) {
    return Request(product + '/productRest/getRecommendedProductList', { methods: 'POST', data, type: 'json' })
}

//获取拼团列表数据
export function getGroupListData(data = {}) {
    return Request('/market/groupList', { methods: 'POST', data, type: 'json' })
}

// 首页店铺筛选
export function getSotreList(data = {}) {
    return Request('/jic-manager/api/store/getStoreList', { methods: 'POST', data })
}

// 学校专区单个学校
export function queryByStoreCode(data = {}) {
    return Request('/jic-manager/api/store/queryByStoreCode', { methods: 'POST', data, type: 'json' })
}

//获取脱敏手机号
export function getDesensitizedPhone(data = {}) {
    return Request(user + '/apiMember/getMemberMobileByToken', { methods: 'POST', data, type: 'json' })
}

// 获取短信验证码(更改手机号绑定页面)
export function sendVerificationCode(data = {}) {
    return Request(user + '/apiMember/getMessageCode', { methods: 'POST', data, type: 'json' });
}

// 提交校验短信验证码(更改手机号绑定页面)
export function checkIdByVerificationCode(data = {}) {
    return Request(user + '/apiMember/checkMemberMobileByToken', { methods: 'POST', data, type: 'json' });
}

// 查询物流接口
export function getLogistics(data = {}) {
    return Request(order + '/order/getDeliveryByOrderNo', { methods: 'POST', data, type: 'json' })
}

//判断用户是否设置过密码（修改登录密码页面）
export function judgePassworded(data = {}) {
    return Request(user + '/apiMember/getMemberSettingPasswordByToken', { methods: 'POST', data, type: 'json' })
}

// 网站反馈接口
export function feedBack(data = {}) {
    return Request(user + '/apiFeedBack/addFeedBack', { methods: 'POST', data, type: 'json' })
}

// 查询积分数据
export function integralInfo(data = {}) {
    return Request(user + '/apiMember/getMemberInfo', { methods: 'POST', data, type: 'json' })
}

// 查询积分分页
export function integralList(data = {}) {
    return Request(user + '/integralManagelog/queryMemberBaseList', { methods: 'POST', data, type: 'json' })
}

// 验证用户输入密码（设置/修改密码时）
export function checkCountPassword(data = {}) {
    return Request(user + '/apiMember/updateMemberPassWordByToken', { methods: 'POST', data, type: 'json' })
}

// 我的拼团列表
export function myGrouponList(data = {}) {
    return Request(market + '/groupon-rest/my-groupon-list', { methods: 'POST', data })
}

// 修改手机号（设置/修改密码时）
export function changePhoneNumber(data = {}) {
    return Request(user + '/apiMember/updateMemberMobileByToken', { methods: 'POST', data, type: 'json' })
}

// 我的评价列表页面
export function evaluateList(data = {}) {
    return Request(order + '/order/getOrderSensitiveList', { methods: 'POST', data, type: 'json' })
}

// 查询充值卡列表
export function rechargeCardList(data = {}) {
    return Request(user + '/apiRechargeCard/getRechargeCardPageList', { methods: 'POST', data, type: 'json' })
}

//查询充值卡明细
export function rechargeCardRecordList(data = {}) {
    return Request(user + '/apiRechargeCard/getRechargeCardRecordPageList', { methods: 'POST', data, type: 'json' })
}

//新增充值卡
export function bindRechargeCard(data = {}) {
    return Request(user + '/apiRechargeCard/bindRechargeCard', { methods: 'POST', data, type: 'json' })
}

// 发表评论/追评
export function updateProductComment(data = {}) {
    return Request('/jic-product/apiProductComment/updateProductComment', { methods: 'POST', data, type: 'json' })
}

// 保存订单发票信息
export function saveOrderInvoice(data = {}) {
    return Request(order + '/order/saveOrderInvoice', { methods: 'POST', data, type: 'json' })
}

// 获取首页配置数据 conf
export function getIndexConf(data = {}) {
    return Request(manager + '/apiCmsModule/getIndexCmsConf', { methods: 'POST', data, type: 'json' })
}

// 获取首页配置商品数据
export function getList(data = {}) {
    return Request(manager + '/apiCmsModule/GetCmsProductList', { methods: 'POST', data, type: 'json' })
}

// 申请售后页面获取物流公司列表
export function getLogisticsList(data = {}) {
    return Request(order + '/afterSale/queryLogisticsCompanyList', { methods: 'POST', data, type: 'json' })
}


// 未开始秒杀活动商品列表
export function queryWillSeckillList(data = {}) {
    return Request(market + '/rest/seckill/query-about-start-goods-list-page', { methods: 'POST', data, type: 'json' })
}

// 进行中秒杀活动商品列表
export function querySeckillProductList(data = {}) {
    return Request(market + '/rest/seckill/query-processing-goods-list-page', { methods: 'POST', data, type: 'json' })
}

// 未开始秒杀活动商品列表
export function querySeckilledProductList(data = {}) {
    return Request(market + '/rest/seckill/query-has-not-start-goods-list-page', { methods: 'POST', data, type: 'json' })
}

// 查询时间段
export function queryPeriodTime(data = {}) {
    return Request(market + '/rest/seckill/query-period-Time', { methods: 'POST', data, type: 'json' })
}

// 首页拼团活动活动列表
export function getGroupThemeList(data = {}) {
    return Request(market + '/rest/groupon/queryGroupProductList', { methods: 'POST', data, type: 'json' })
}

// 查询当前活动已开团未成团的列表
export function getCurrentJoinedGroupList(data = {}) {
    return Request(market + '/rest/groupon/current-joined-groupon-list', { methods: 'POST', data, type: 'json' })
}

// 查询拼团详情
export function getCurrentJoinedGroupInfo(data = {}) {
    return Request(market + '/rest/groupon/getCurrentJoinedGroupInfo', { methods: 'POST', data, type: 'json' })
}

// 查询我的拼团列表
export function getMyGroupList(data = {}) {
    return Request(market + '/rest/groupon/getMyGroupList', { methods: 'POST', data, type: 'json' })
}

// 首页数据
export function getModuleCmsConf(data = {}) {
    return Request(conf + '/cmsPageModule/getModuleCmsConf', { methods: 'POST', data, type: 'json' })
}

// 查询首页分类数据
export function getClassifyData(data = {}) {
    return Request(product + '/categoryRest/queryRestCategoryForIndex', { methods: 'POST', data, type: 'json' })
}

// 查询分类数据
export function getClassifyProduct(data = {}) {
    return Request(product + '/productRest/queryRestPorduct', { methods: 'POST', data, type: 'json' })
}

// 修改昵称
export function getUpdatePersonalInfo(data = {}) {
    return Request(user + '/apiMemberInfo/updateMemberInfo', { methods: 'POST', data, type: 'json' })
}

// 个人中心信息提醒查询
export function getUserInfo2(data = {}) {
    return Request(user + '/information/queryMemberInformationList', { methods: 'POST', data, type: 'json' })
}

// 消息提醒标记已读
export function readUserInfo(data = {}) {
    return Request(user + '/information/updateMemberInformation', { methods: 'POST', data, type: 'json' })
}

// 消息提醒删除
export function deleteUserInfo(data = {}) {
    return Request(user + '/information/deleteMemberInformation', { methods: 'POST', data, type: 'json' })
}

// 获取店铺信息
export function queryShopInfo(data = {}) {
    return Request(manager + '/api/store/getMemStoreInfoById', { methods: 'POST', data, type: 'json' })
}

// 店铺详情 - 商品列表数据
export function queryShopProductInfo(data = {}) {
    return Request(product + '/productRest/queryRestPorduct', { methods: 'POST', data, type: 'json' })
}

// 查询店铺分类 - 一级类目
export function queryStoreSecondCategory(data = {}) {
    return Request(product + '/categoryRest/queryStoreSecondCategory', { methods: 'POST', data, type: 'json' })
}

// 查询店铺分类 - 二级三级级类目
export function queryStoreSecondSonCategory(data = {}) {
    return Request(product + '/categoryRest/queryStoreSecondSonCategory', { methods: 'POST', data, type: 'json' })
}

// 获取砍价活动列表
export function getBargainList(data = {}) {
    return Request(market + '/rest/bargain/listRestPage', { methods: 'POST', data, type: 'json' })
}

// 获取砍价活动详情
export function getBargainInfo(data = {}) {
    return Request(market + '/rest/bargain/getInvolvedNow', { methods: 'POST', data, type: 'json' })
}

// 获取砍价记录
export function getMyBargainLog(data = {}) {
    return Request(market + '/rest/bargain/getMyBargainLog', { methods: 'POST', data, type: 'json' })
}

// 获取我的砍价
export function getMyBargainGoods(data = {}) {
    return Request(market + '/rest/bargain/getMyBargain', { methods: 'POST', data, type: 'json' })
}

// 查询历史搜索
export function queryMProductSearchHistoryList(data = {}) {
    return Request(product + '/productSearchHistoryRest/queryMProductSearchHistoryList', {
        methods: 'POST',
        data,
        type: 'json'
    })
}

// 新增历史搜索
export function saveMProductSearchHistory(data = {}) {
    return Request(product + '/productSearchHistoryRest/saveMProductSearchHistory', {
        methods: 'POST',
        data,
        type: 'json'
    })
}

// 查询轮播图
export function querySwipeImgs(data = {}) {
    return Request('/jic-manager/apiSysCarouselFigure/listSysCarouselFigure', { methods: 'POST', data, type: 'json' })
}

// 查询商品砍价信息
export function queryGoodsBarginInfo(data = {}) {
    return Request(market + '/rest/bargain/getMyBargainInfo', { methods: 'POST', data, type: 'json' })
}

// 删除历史搜索
export function deleteMProductSearchHistory(data = {}) {
    return Request(product + '/productSearchHistoryRest/deleteMProductSearchHistory', {
        methods: 'POST',
        data,
        type: 'json'
    })
}

// 获取所有商品品牌信息
export function barandRestListRestPage(data = {}) {
    return Request(product + '/barandRest/listRestPage', { methods: 'POST', data, type: 'json' })
}

// 获取前台所有叶子类目
export function categoryRestListRestPage(data = {}) {
    return Request(product + '/categoryRest/listRestPage', { methods: 'POST', data, type: 'json' })
}

// 查询分销员基本信息
export function getDistributionUserInfo(data = {}) {
    return Request(user + '/apiDistribution/getDistributionUserInfo', { methods: 'POST', data, type: 'json' })
}

// 累计佣金
export function getCommissionCount(data = {}) {
    return Request(user + '/apiDistribution/getCommissionCount', { methods: 'POST', data, type: 'json' })
}

// 累计明细
export function getCommissionListPage(data = {}) {
    return Request(user + '/apiDistribution/getCommissionListPage', { methods: 'POST', data, type: 'json' })
}

// 提现
export function getWithdrawalCount(data = {}) {
    return Request(user + '/apiDistribution/getWithdrawalCount', { methods: 'POST', data, type: 'json' })
}

// 提现明细
export function getWithdrawalListPage(data = {}) {
    return Request(user + '/apiDistribution/getWithdrawalListPage', { methods: 'POST', data, type: 'json' })
}

// 我的团队
export function getMyTeam(data = {}) {
    return Request(user + '/apiDistribution/getMyTeam', { methods: 'POST', data, type: 'json' })
}

// 我的推广二维码
export function queryDistributorShare(data = {}) {
    return Request(user + '/apiDistribution/queryDistributorShare', { methods: 'POST', data, type: 'json' })
}

// 分销订单
export function getDistributionOrderListPage(data = {}) {
    return Request(user + '/apiDistribution/getDistributionOrderListPage', { methods: 'POST', data, type: 'json' })
}

// 添加上级或者下级
export function addHigherOrLower(data = {}) {
    return Request(user + '/apiDistribution/addHigherOrLower', { methods: 'POST', data, type: 'json' })
}

// 佣金提现
export function getWithdrawalInfo(data = {}) {
    return Request(user + '/apiDistribution/getWithdrawalInfo', { methods: 'POST', data, type: 'json' })
}

// 我要提现
export function saveApply(data = {}) {
    return Request(user + '/apiDistribution/saveApply', { methods: 'POST', data, type: 'json' })
}

// 分享商品
export function shareGoods(data = {}) {
    return Request(product + '/productRest/shareGoods', { methods: 'POST', data, type: 'json' })
}

// 立即砍价/继续砍价
export function helpBargain(data = {}) {
    return Request(market + '/rest/bargain/helpBargain', { methods: 'POST', data, type: 'json' })
}

// 分享初始化
export function initWXJSSDKConfigInfo(data = {}) {
    return Request(user + '/api/common/initWXJSSDKConfigInfo', { methods: 'POST', data, type: 'json' })
}
// 微信登录
export function wxLogin(data = {}) {
    return Request(user + '/api/common/internal/wxLogin', { methods: 'POST', data })
}
// 分类商品列表
export function queryRestPorduct(data = {}) {
    return Request(product + '/productRest/queryRestPorduct', { methods: 'POST', data, type: 'json' })
}


// 协议类型列表
export function sysPageList(data = {}) {
    return Request(manager + '/sysAgreement/PageList', { methods: 'POST', data, type: 'json' })
}
//协议详情
export function sysPageDetail(data = {}) {
    return Request(manager + '/sysAgreement/PageId', { methods: 'POST', data, type: 'json' })
}
//帮助中心列表
export function queryArticleList(data = {}) {
    return Request(manager + '/articleApi/queryArticleListByCategory', { methods: 'POST', data, type: 'json' })
}
//帮助中心详情
export function queryArticleDetail(data = {}) {
    return Request(manager + '/articleApi/queryArticleDetail', { methods: 'POST', data, type: 'json' })
}

//个人信息
export function queryMemberInfo(data = {}) {
    return Request(user + '/api/common/queryMemberInfo', { methods: 'POST', data, type: 'json' })
}
//个人信息修改
export function updateMemberInfo(data = {}) {
    return Request(user + '/api/common/updateMemberInfo', { methods: 'POST', data, type: 'json' })
}
//查询全部的商品品牌
export function queryProductBrandAll(data = {}) {
    return Request(product + '/productBrand/queryPage', { methods: 'POST', data, type: 'json' })
}
// 订单列表接口
export function queryPickAllList(data = {}) {
    return Request(order + '/order/queryPickAllList', { methods: 'POST', type: 'json', data })
}

// 商品优惠信息
export function getPromotinInfo(data = {}) {
    return Request(market + '/rest/promotion/getPromotinInfo', { methods: 'POST', data, type: 'json' })
}

// 商品列表促销聚合页
export function queryPolymericInfo(data = {}) {
    return Request(market + '/rest/promotion/queryPromotionPolymericInfo', { methods: 'POST', data, type: 'json' })
}

// 活动团单详情
export function queryLaunchGrouponOrderInfo(data = {}) {
    return Request(market + '/rest/groupon/queryLaunchGrouponOrderInfo', { methods: 'POST', data, type: 'json' })
}

// 聚合用户信息及微常准用户信息
export function getAggregationUserInfo(data = {}) {
    return Request(user + '/api/user/getAggregationUserInfo', { methods: 'POST', data, type: 'json' })
}

// 获取可用的话费抵用券活动
export function getPhoneCouponCenter(data = {}) {
    return Request(market + '/rest/coupon/getPhoneCouponCenter', { methods: 'POST', data, type: 'json' })
}

// 获取虚拟商品列表
export function queryGoodsByType(data = {}) {
    return Request(product + '/productRest/queryGoodsByType', { methods: 'POST', data, type: 'json' })
}

//下单
export function addOrderInfo(data = {}) {
    return Request(order + '/trade-settle/order', { methods: 'POST', data, type: 'json' })
}

//下单校验自然月短信验证码
export function haierOrderCount(data) {
    return Request(order + "/feign/haierOrderCount", {
      methods: "POST",
      data,
      type: "json",
    });
  }
//退换货
export function orderAfterAaleComplaintByPage(data) {
    return Request(order + "/feign/orderAfterAaleComplaintByPage", {
      methods: "POST",
      data,
      type: "json",
    });
  }

//商品预计算
export function preOrder(data = {}) {
    return Request(market + '/order/cost/preOrder', { methods: 'POST', data, type: 'json' })
}

// 查询商品
export function queryByLocation(data) {
    return Request('/jic-manager/sysManagement/queryByLocation', { methods: 'POST', data, type: 'json' })
}















/////////////////////////////////////////////////
//海尔商城



//商品列表
export function getproductlist(data = {}) {
    return Request(product + '/productPcApi/listCommoditySpecificationParameters', { methods: 'POST', data, type: 'json' })
}





//用户总积分查询
export function totalPoint(data = {}) {
    return Request(point + '/shoppingMall/user/userTotalPoint', { methods: 'GET', data, type: 'json' })
}

//订单分页列表
export function getOrdersList(data = {}) {
    return Request(trade + '/shoppingMall/order/orderList', { methods: 'POST', data, type: 'json' })
}

// 物流信息
export function getLogisticsDetails(data = {}) {
    return Request(order + '/shoppingMall/order/selctHzyGigtExpressV2', { methods: 'POST', data, type: 'json' })
}
// 短信信息
export function selectVirtuallyExpress(data = {}) {
    return Request(order + '/order/vcenter/selectVirtuallyExpress', { methods: 'POST', data, type: 'json' })
}
//商品评论
export function getProductCommentApi(data = {}) {
    return Request(product + '/mProductComment/queryByProductIdComment', { methods: 'POST', data, type: 'json' })
}

//商品详情
export function getProductDetails(data = {}) {
    return Request(product + '/mProduct/getByProductId', { methods: 'POST', data, type: 'json' })
}

//商品列表分页
export function queryPageHaierApi(data = {}) {
    return Request(product + '/productManagement/queryPageHaierByPointDesc', { methods: 'POST', data, type: 'json' })
}

//区域有无货
export function queryByProductIdAndSaleAreaIdApi(data = {}) {
    return Request(product + '/productSaleAreaRelation/queryByProductIdAndSaleAreaId', { methods: 'POST', data, type: 'json' })
}


// 查询积分卡是否存在
export function getPointCardExit(data = {}) {
    return Request(point + '/api/point/query/getPointCardExit', { methods: 'GET', data, type: 'json' })
}


// 激活积分卡
export function activateCardPoint(data = {}) {
    return Request(point + '/api/point/query/activateCardPoint', { methods: 'POST', data, type: 'json' })
}

// 获取用户收货地址
export function searchUserAddrList(data = {}) {
    return Request(interaction + '/userAddress/searchUserAddrList', { methods: 'GET', data, type: 'json' })
}


// 获取用户默认收货地址
export function searchUserAddrDefault(data = {}) {
    return Request(interaction + '/userAddress/searchUserAddrDefault', { methods: 'GET', data, type: 'json' })
}

// 删除地址
export function deleteUserAddr(data = {}) {
    return Request(interaction + '/userAddress/deleteUserAddr', { methods: 'POST', data, type: 'json' })
}

//添加用户地址
export function addUserAddr(data = {}) {
    return Request(interaction + '/userAddress/addUserAddr', { methods: 'POST', data, type: 'json' })
}

//修改用户地址
export function updateUserAddr(data = {}) {
    return Request(interaction + '/userAddress/updateUserAddr', { methods: 'POST', data, type: 'json' })
}



//用户信息
export function getUserInfo(data = {}) {
    return Request(interaction + '/userRegister/getUserInfo', { methods: 'GET', data, type: 'json' })
}


//客服-用户问题新增
export function saveOrUpdateSysMemDialog(data) {
    return Request(conf + '/memDialogue/saveOrUpdate', { methods: 'POST', data, type: 'json' })
}

//首页菜单
export function queryBeforeCategory(data) {
    return Request(product + '/category/queryBeforeCategory', { methods: 'POST', data, type: 'json' })
}

//下单
export function haierCreateOrder(data) {
    return Request(order + '/feign/haierCreateOrderForeign', { methods: 'POST', data, type: 'json' })
}

//下单校验地区
export function haierOrderCheckArea(data) {
    return Request(order + '/feign/haierOrderCheckArea', { methods: 'POST', data, type: 'json' })
}

//下单校验库存
export function haierOrderCheckQuantity(data) {
    return Request(order + '/feign/haierOrderCheckQuantity', { methods: 'POST', data, type: 'json' })
}
//下单校验库存2
export function productStok(data) {
    return Request(interaction + "/productStock/productStock", {
      methods: "POST",
      data,
      type: "json",
    });
  }

//获取首页cms配置数据
export function haierGetModuleCmsConf(data) {
    return Request(conf + '/apiCmsModule/getIndexCmsConf', { methods: 'POST', data, type: 'json' })
}

//海尔付款
export function haierOrderPay(data) {
    return Request(order + '/feign/haierOrderPay', { methods: 'POST', data, type: 'json' })
}

//查询省市区表
export function sysUserProvince(data) {
    return Request(conf + '/sysUserProvince/query', { methods: 'POST', data, type: 'json' })
}

//查询省表
export function sysUserProvinceListAll(data) {
    return Request(conf + '/sysUserProvince/listAll', { methods: 'POST', data, type: 'json' })
}

//查询市表
export function sysUserCityListAll(data) {
    return Request(conf + '/sysUserCity/listAll', { methods: 'POST', data, type: 'json' })
}

//查询区表
export function sysUserAreaListAll(data) {
    return Request(conf + '/sysUserArea/listAll', { methods: 'POST', data, type: 'json' })
}

//【省直辖市】
export function listSameCityArea(data) {
    return Request(conf + '/sysUserCity/listSameCityArea', { methods: 'POST', data, type: 'json' })
}

//根据id查找商品详情
export function queryByProductId(data) {
    return Request(product + '/mProduct/queryByProductId', { methods: 'POST', data, type: 'json' })
}

//查询用户定制卡列表
export function getUserPointCard(data) {
    return Request(point + '/confPointCard/getUserPointCard', { methods: 'POST', data, type: 'json' })
}

//实物卡下单
export function placeAnOrder(data) {
    return Request(point + '/cardAndOrder/placeAnOrder', { methods: 'POST', data, type: 'json' })
}

//用户收藏分页列表
export function collectListPage(data) {
    return Request(user + '/mMemberCollect/listPage', { methods: 'POST', data, type: 'json' })
}

//添加收藏商品
export function collectSave(data) {
    return Request(user + '/mMemberCollect/saveOrUpdate', { methods: 'POST', data, type: 'json' })
}

//取消收藏商品
export function collectDelete(data) {
    return Request(user + '/mMemberCollect/delete', { methods: 'POST', data, type: 'json' })
}


//分类id查询列表
export function listBrandName(data) {
    return Request(product + '/productPcApi/listBrandName', { methods: 'POST', data, type: 'json' })
}

//上传图片
export function uploadImg(data) {
    return Request("/jic-filecenter/api/ali/upload", { methods: 'POST', data, type: 'file' })
}

//确认收货
export function confirmReceipt(data) {
    return Request(order + '/feign/confirmReceipt', { methods: 'POST', data, type: 'json' })
}
//通知公告
export function sysNotice(data) {
    return Request(conf + '/sysNotice/queryList', { methods: 'POST', data, type: 'json' })
}

//订单到期事件
export function selHaierOrderOverdue(data) {
    return Request(order + '/feign/selHaierOrderOverdue', { methods: 'POST', data, type: 'json' })
}

//获取token
export function getUserToken(data) {
    return Request(interaction + '/byTokenUserRegisterApi/getUserToken', { methods: 'POST', data, type: 'json' })
}
//获取token2
export function getUserTokens(data) {
    return Request(interaction + '/byTokenUserRegisterApi/avoid-the-login', { methods: 'POST', data, type: 'json' })
}
//获取token3
export function UserTokens(data) {
    return Request(interaction + '/byTokenUserRegisterApi/getUserToken-QR-Code', { methods: 'POST', data, type: 'json' })
}
//发表评论
export function mProductComment(data) {
    return Request(product + '/mProductComment/saveOrUpdate', { methods: 'POST', data, type: 'json' })
}
//加入购物车
export function haierOrderShoppingCart(data) {
    return Request(order + '/feign/haierOrderShoppingCart', { methods: 'POST', data, type: 'json' })
}
//购物车列表
export function selHaierShoppingCart(data) {
    return Request(order + '/feign/selHaierShoppingCart', { methods: 'POST', data, type: 'json' })
}
//购物车删除
export function haierDelShoppingCart(data) {
    return Request(order + '/feign/haierDelShoppingCart', { methods: 'POST', data, type: 'json' })
}
//短信发送接口
export function sendMsg(data) {
    return Request(interaction + '/public/communication/message/sendMsg', { methods: 'POST', data, type: 'json' })
}
//短信验证
export function verifyCodeMemberReceived(data) {
    return Request(interaction + '/public/communication/message/verifyCodeMemberReceived', { methods: 'POST', data, type: 'json' })
}
// 校验单笔下单最大额度
export function getByRiskRule(data = {}) {
    return Request(point + '/moniRiskRule/getByRiskRule', { methods: 'POST', data, type: 'json' })
}
// 规格sku
export function AndProperty(data = {}) {
    return Request(product + '/mProduct/getSkuProductByProductIdAndProperty', { methods: 'POST', data, type: 'json' })
}

//商品描述 2021-3-23 11:01:48 tzc
export function queryProductDescribe(data = {}) {
    return Request(product + "/productDescribe/queryProductDescribe", {
      methods: "POST",
      data,
      type: "json",
    });
  }

  //审核资料

export function addToExamineImages(data) {
    return Request(order + "/feign/addToExamineImages", {
      methods: "POST",
      data,
      type: "json",
    });
  }


  //退换货
//   订单查询
export function getOrderByNo(data) {
    return Request(order + "/mOrderReturns/getOrderByNo", {
      methods: "POST",
      data,
      type: "json",
    });
  }
//   查询售后信息包含受理信息
export function getByPrimaryKey(data) {
    return Request(order + "/mOrderReturns/getByPrimaryKey", {
      methods: "POST",
      data,
      type: "json",
    });
  }
//   保存售后信息 
export function returnSave(data) {
    return Request(order + "/mOrderReturns/saveOrUpdate", {
      methods: "POST",
      data,
      type: "json",
    });
  }


  //扫码激活
  export function getPointCardPasswordAndCardNo(data){
    return Request(point + "/confPointCard/getPointCardPasswordAndCardNo", {
        methods: "GET",
        data,
        type: "json",
      });
  }
  // 添加会员
export function addMember(data = {}) {
    return Request(user + "/api/user/addMemberForApp", {
      methods: "POST",
      data,
      type: "json",
    });
  }

    // 商品全局公告
export function queryNoticeByTime(data = {}) {
    return Request(conf + '/sysNotice/queryNoticeByTime', {
      methods: "POST",
      data,
      type: "json",
    });
}
//   感恩月用户卡券对应商品
export function provideCardGoodList(data = {}) {
    return Request(point + '/giftVoucher/provideCardGoodList', { methods: 'POST', data, type: 'json' })
}
//   感恩月用户卡券兑换创建订单
export function giftVoucherHaierCreateOrder(data = {}) {
    return Request(point + '/giftVoucher/haierCreateOrder', { methods: 'POST', data, type: 'json' })
}
// 根据id查库存
export function queryStoreByProduct(data={}) {
    return Request(product + "/productList/queryStoreByProductWeb", {
      methods: "POST",
      data,
    });
  }
// 修改发货地址
export function mOrderModReceLogSave(data={}) {
    return Request(order + "/mOrderModReceLog/save", {
      methods: "POST",
      data,
      type:'json'
    });
  }

  // 查询订单物流
export function haierOrderBale(data={}) {
    return Request(order + "/orderBale/haierOrderBale", {
      methods: "POST",
      data,
      type:'json'
    });
  }
  // 查询订单公告
export function getOrderNotice(data={}) {
    return Request(manager + "/announcement/getOrderNotice", {
      methods: "POST",
      data,
      type:'json'
    });
  }
//   删除订单
export function deleteOrderByOrderNo(data={}) {
    return Request(order + "/shoppingMall/order/deleteOrderByOrderNo", {
      methods: "POST",
      data,
      type:'json'
    });
  }
  //   用户是否能够领取智家联合卡(plus会员卡)接口
export function checkUserGivePlus(data={}) {
    return Request(order + "/feign/checkUserGivePlus", {
      methods: "POST",
      data,
      type:'json'
    });
  }
  //   用户领取联合卡(会员)接口
export function receiveGivePlus(data={}) {
    return Request(order + "/feign/receiveGivePlus", {
      methods: "POST",
      data,
      type:'json'
    });
  }

  //   洗衣机商品列表
  export function findWashProductList(data={}) {
    return Request(manager + "/apiCmsModule/findWashProductList", {
      methods: "POST",
      data,
      type:'json'
    });
  }
  //   催发货
  export function mOrderExpeditingSaveOrUpdate(data={}) {
    return Request(order + "/mOrderExpediting/saveOrUpdate", {
      methods: "POST",
      data,
      type:'json'
    });
  }
//   是否会员

export function isMemberPlus(data={}) {
    return Request(order + "/feign/member/isMemberPlus", {
        methods: "POST",
        data,
        type:'json'
    });
}

//   获取plus专属商品列表
export function findPlusProductList(data={}) {
    return Request(product + "/productPcApi/findPlusProductList", {
        methods: "POST",
        data,
        type:'json'
    });
}

export function getProductByGiftId(data={}) {
    return Request(point + "/api/http/point/getProductByGiftId", {
        methods: "POST",
        data,
        type:'json'
    });
}
